import { useMutation } from '@tanstack/react-query';

import { useLatestMutationData } from '@hcs/hooks';

import { OrderManagerApi } from '../api/orderManagerApi';
import { OrderItemsSearchInputs } from '../types';

export const useOrderItemsSearch = () => {
  // Return the latest successful result
  // Prevents results in autocomplete components from disappearing as the user types
  return useLatestMutationData(
    useMutation({
      mutationFn: (orderItemsSearchInputs: OrderItemsSearchInputs) =>
        OrderManagerApi.fetchOrderItemsSearch(orderItemsSearchInputs),
    }),
  );
};
